export const BRASS_CZ_COLOUR_STONE_IMITATION = "BRASS-CZ-COLOUR STONE (IMITATION)";

const BRASS_CZ_COLOUR_STONE_ALIASES = new Set([
  "BRASS-CZ-COLOR STONE",
  "BRASS-CZ-COLOUR STONE",
  "BRASS-CZ-COLOR STONE (IMITATION)",
  BRASS_CZ_COLOUR_STONE_IMITATION,
]);

const normalizeMaterialToken = (value = "") =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();

export const normalizeMaterialLabel = (value = "") => {
  const trimmedValue = String(value || "").trim().replace(/\s+/g, " ");

  if (!trimmedValue) {
    return "";
  }

  return BRASS_CZ_COLOUR_STONE_ALIASES.has(normalizeMaterialToken(trimmedValue))
    ? BRASS_CZ_COLOUR_STONE_IMITATION
    : trimmedValue;
};
